import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Button,
  Card,
  Label,
  Input,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../assets/images/imageupload.svg";
import { useSelector } from "react-redux";

const AddStaff = () => {
  const [equipmentFiles, setEquipmentFiles] = useState({ files: [] });
  const [userRoles, setUserRoles] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  {
    isUpdate
      ? (document.title = "Edit Staff | Elevated - Admin Dashboard")
      : (document.title = "Add Staff | Elevated - Admin Dashboard");
  }
  const [staffId, setStaffId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { currentUser } = useSelector((state) => state.auth);
  const isEditingSelf = currentUser.id === staffId;
  const [permissionsList, setPermissionsList] = useState({
    gym: ["View Gym", "Create Gym", "Update Gym", "Delete Gym"],
    passes: ["View Pass", "Create Pass", "Update Pass", "Delete Pass"],
    equipment: [
      "View Equipment",
      "Create Equipment",
      "Update Equipment",
      "Delete Equipment",
    ],
    blog: ["View Blog", "Create Blog", "Update Blog", "Delete Blog"],
    staff: ["View Staff", "Create Staff", "Update Staff", "Delete Staff"],
    user: ["Active User", "Block User", "Archive User"],
    other: ["Term", "Privacy Policy", "FAQ", "Request A Feature", "Contact Us"],
    billing: ["Gym Transaction", "Gym Revenue", "Payment Payout"],
  });
  const [image, setImage] = useState("");
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    email: "",
    phoneNumber: "",
    userRole: "",
    userRoleId: "",
    file: "",
    userPermissions: {},
    gymId: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const fetchUserRole = async () => {
    const resp = await get(`${endpoints.roles}`);
    if (resp?.data?.success) {
      setUserRoles(resp?.data?.data);
    }
  };
  useEffect(() => {
    fetchUserRole();
  }, []);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const staffFromParams = searchParams.get("staffId");
    setStaffId(staffFromParams);
    if (staffFromParams) {
      setIsUpdate(true);
    }
  }, [location.search]);
  useEffect(() => {
    const fetchStaffDetails = async (id) => {
      try {
        const response = await get(`${endpoints.staff}/${id}`);
        if (response?.data) {
          const staffData = response.data.data;
          const matchedRole = userRoles.find(
            (role) => role.name === staffData.userRole
          );

          setInitialValues({
            firstName: staffData?.firstName || "",
            email: staffData?.email || "",
            phoneNumber: staffData?.phoneNumber || "",
            userRole: staffData?.userRole || "",
            userRoleId: matchedRole?.id || "",
            profileImage: staffData?.additionalInfo?.profileImage || "",
            userPermissions: staffData?.userPermissions,
            gymId: staffData?.gymId || "", // Set gymId from staff data
          });

          if (staffData?.additionalInfo?.profileImage) {
            const imageUrl = `${process.env.REACT_APP_IMG_URL}${staffData?.additionalInfo?.profileImage}`;
            setImage(imageUrl);
          }
        } else {
          toast.error("No data found of staff", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } catch (error) {
        console.error("Error fetching staff details:", error, error.message);
        toast.error("Failed to fetch staff details. Please try again.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }
    };

    if (isUpdate && staffId) {
      fetchStaffDetails(staffId);
    }
    setImage("");
  }, [isUpdate, staffId, userRoles]);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "Name must be at least 2 characters")
      .max(50, "Name cannot exceed 50 characters")
      .matches(/^[A-Za-z ]+$/, "Name can only contain letters and spaces")
      .required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phoneNumber: Yup.string()
      .matches(
        /^\d{11}$/,
        "Phone number must be 11 digits and contain only numbers"
      )
      .required("Phone number is required"),
    // userRole: Yup.string().required("Role is required"),
  });

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newMediaFiles = files.filter(
      (file) => file.type.startsWith("image/") || file.type.startsWith("video/")
    );

    setEquipmentFiles((prev) => ({
      files: [...prev.files, ...newMediaFiles],
    }));
  };
  const handleFileRemove = () => {
    setEquipmentFiles({ files: [] });
    setImage("");
    document.getElementById("equipmentFileInput").value = "";
  };
  function cleanPermissions(permissions) {
    const cleanedPermissions = {};

    Object.entries(permissions).forEach(([key, value]) => {
      // Filter out any keys where the value is false (including "selected" and others)
      const subPermissions = Object.entries(value)
        .filter(([subKey, subValue]) => subValue === true) // Keep only true values
        .reduce((acc, [subKey, subValue]) => {
          acc[subKey] = subValue;
          return acc;
        }, {});

      // Only add the key if there are any remaining sub-permissions
      if (Object.keys(subPermissions).length > 0) {
        cleanedPermissions[key] = subPermissions;
      }
    });

    return cleanedPermissions;
  }

  const handleSubmit = async (values, { setFieldError }) => {
    // Check if gym is required and not selected
    if ((appRole === "gymOwner" || appRole === "gymStaff") && !seletedGymId) {
      setFieldError("gymId", "Please select a gym before submitting.");
      return; // Stop the submission if no gym is selected
    }

    const formData = new FormData();
    formData.append("firstName", values.firstName);
    formData.append("email", values.email);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("userRole", values.userRole);
    formData.append("userRoleId", values.userRoleId);
    const cleanedPermissions = cleanPermissions(values.userPermissions);
    formData.append("userPermissions", JSON.stringify(cleanedPermissions));
    formData.append("file", equipmentFiles.files[0]);
    if (appRole === "gymOwner" || appRole === "gymStaff") {
      formData.append("gymId", seletedGymId);
      formData.append("userAppRole", "gymStaff");
    }

    try {
      setIsSubmitting(true);
      if (isUpdate) {
        const resp = await put(`${endpoints.user}/${staffId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (resp?.data?.success) {
          toast.success("Staff Updated Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });

          navigate("/list-staff");
        } else if (resp?.data?.success === "false") {
          toast.error(resp?.response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.error(resp?.response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } else {
        const resp = await post(endpoints.staff, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (resp?.data?.success) {
          toast.success("Staff Added Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          navigate("/list-staff");
        } else if (resp?.response?.data) {
          toast.error(resp?.response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.error("Something went wrong!", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const togglePermission = (permission, values, setFieldValue) => {
    const isChecked = !values.userPermissions?.[permission]?.selected;

    const updatedSubPermissions = permissionsList[permission].reduce(
      (acc, sub) => {
        acc[sub] = isChecked;
        return acc;
      },
      {}
    );

    // Update the permission in Formik
    setFieldValue("userPermissions", {
      ...values.userPermissions,
      [permission]: { selected: isChecked, ...updatedSubPermissions },
    });
  };

  const toggleSubPermission = (
    permission,
    subPermission,
    values,
    setFieldValue
  ) => {
    const currentPermission = values.userPermissions?.[permission] || {};

    const updatedSubPermissions = {
      ...currentPermission,
      [subPermission]: !currentPermission[subPermission],
    };

    const allSelected = permissionsList[permission]?.every(
      (sub) => updatedSubPermissions[sub]
    );

    // Update the permission in Formik
    setFieldValue("userPermissions", {
      ...values.userPermissions,
      [permission]: { ...updatedSubPermissions, selected: allSelected },
    });
  };
  const { appRole, id } = useSelector((state) => state.auth.currentUser);
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState("");
  const gymIds = async () => {
    const resp = await get(`${endpoints.gym}/admin?userId=${id}&limit=50`);
    if (resp?.data?.success) {
      setGymData(resp.data.data);

      setSelectedGym(resp.data.data[0]?.name);
      setSeletedGymId(resp.data.data[0]?._id);
    }
  };

  useEffect(() => {
    if (appRole == "gymOwner" || appRole == "gymStaff") {
      gymIds();
    }
  }, []);
  return (
    <Container fluid>
      <Row>
        <Col>
          <Card className="rounded-4">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { setFieldError }) =>
                handleSubmit(values, { setFieldError })
              }
              enableReinitialize
            >
              {({ errors, touched, resetForm, setFieldValue, values }) => (
                <Form className="p-4">
                  <h3 className="primary-black ff-sora font-size-20 fw-bold">
                    {isUpdate ? "Edit Staff" : "Add New Staff"}
                  </h3>

                  {/* Profile Media */}
                  <h5 className="secondary-black ff-sora font-size-16 fw-normal">
                    Profile Media <span className="text-danger">*</span>
                  </h5>
                  <FormGroup>
                    <div
                      className="cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                      style={{
                        border: "1px dashed #ccc",
                        width: "160px",
                        height: "160px",
                      }}
                      onClick={() =>
                        document.getElementById("equipmentFileInput").click()
                      }
                    >
                      {equipmentFiles.files.length > 0 ? (
                        equipmentFiles.files.slice(-1).map((file, index) => (
                          <div
                            className="position-relative w-100 h-100"
                            key={file.name + index}
                          >
                            {file.type.startsWith("image/") && (
                              <img
                                src={URL.createObjectURL(file)}
                                alt="Uploaded"
                                className="w-100 h-100 object-fit-cover"
                              />
                            )}

                            <button
                              className="rounded-5 "
                              style={{
                                fontSize: "12px",
                                color: "black",
                                cursor: "pointer",
                                zIndex: 1,
                                position: "absolute",

                                top: 10,
                                right: 15,
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleFileRemove();
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))
                      ) : image ? (
                        <img
                          src={image}
                          alt="Uploaded"
                          className="w-100 h-100 object-fit-cover"
                        />
                      ) : (
                        <>
                          <img
                            src={imgupload}
                            alt="Upload"
                            height="40px"
                            width="40px"
                          />
                          <div className="secondary-black text-center mt-2 ff-sora font-size-16 fw-normal">
                            Upload Media
                          </div>
                        </>
                      )}

                      {/* Hidden File Input */}
                      <input
                        type="file"
                        accept="image/*,video/*"
                        multiple
                        id="equipmentFileInput"
                        className="d-none"
                        onChange={handleFileChange}
                      />
                    </div>
                    {errors.file && touched.file && (
                      <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                        {errors.file}
                      </div>
                    )}
                  </FormGroup>

                  {/* General Info */}
                  <h5 className="secondary-black ff-sora font-size-16 fw-normal">
                    General Info <span className="text-danger">*</span>
                  </h5>
                  <Row form className="d-flex justify-content-start">
                    <Col md={4}>
                      <FormGroup>
                        <Field
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          name="firstName"
                          type="text"
                          placeholder="Name"
                          className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4${
                            errors.firstName && touched.firstName
                              ? " is-invalid"
                              : ""
                          }`}
                        />
                        {errors.firstName && touched.firstName && (
                          <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.firstName}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Field
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          name="email"
                          type="email"
                          placeholder="Email"
                          className={`rounded-5 custom-placeholder bg-light ff-sora font-size-16 fw-normal px-4${
                            errors.email && touched.email ? " is-invalid" : ""
                          }`}
                        />
                        {errors.email && touched.email && (
                          <div className="invalid-feedback text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.email}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Field
                          name="phoneNumber"
                          type="text"
                          placeholder="Phone"
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4${
                            errors.phoneNumber && touched.phoneNumber
                              ? " is-invalid"
                              : ""
                          }`}
                        />
                        {errors.phoneNumber && touched.phoneNumber && (
                          <div className="invalid-feedback text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.phoneNumber}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      {(appRole === "gymOwner" || appRole === "gymStaff") && (
                        <FormGroup>
                          <Field
                            name="gymId"
                            as="select"
                            style={{
                              width: "100%",
                              maxWidth: "420px",
                              height: "56px",
                              border: "none",
                            }}
                            className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal form-control ${
                              errors.gymId && touched.gymId ? "is-invalid" : ""
                            }`}
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setSeletedGymId(selectedValue);
                              setFieldValue("gymId", selectedValue); // Update Formik's state
                            }}
                          >
                            <option value="">Select Gym</option>
                            {gymData.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.name}{" "}
                                <small style={{ fontSize: "9px" }}>
                                  (Selected GYM)
                                </small>
                              </option>
                            ))}
                          </Field>
                          {errors.gymId && touched.gymId && (
                            <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                              {errors.gymId}
                            </div>
                          )}
                        </FormGroup>
                      )}
                    </Col>
                  </Row>

                  {/* Roles & Permissions */}
                  {!isEditingSelf && (
                    <h5 className="secondary-black ff-sora font-size-16 fw-normal">
                      Roles & Permissions
                    </h5>
                  )}
                  <Row form>
                    {!isEditingSelf &&
                      Object.entries(permissionsList).map(
                        ([permission, subPermissions], index) => {
                          // Skip rendering "user" and other permissions if appRole is "Gym"
                          if (
                            (appRole == "gymOwner" || appRole == "gymStaff") &&
                            ["user", "other"].includes(permission)
                          ) {
                            return null;
                          }

                          return (
                            <Col md={3} key={index} className={"py-3"}>
                              {/* Parent Permission */}
                              <div className="d-flex align-items-center permissionContainer pb-1">
                                <Input
                                  type="checkbox"
                                  checked={
                                    values?.userPermissions?.[permission]
                                      ?.selected || false
                                  }
                                  onChange={() =>
                                    togglePermission(
                                      permission,
                                      values,
                                      setFieldValue
                                    )
                                  }
                                  className="secondary-black m-0"
                                  style={{
                                    borderColor: "#525252",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                />
                                <span className="ps-2 text-capitalize ff-sora">
                                  {permission}
                                </span>
                              </div>

                              {/* Sub-Permissions */}
                              <div>
                                {subPermissions.map(
                                  (subPermission, subIndex) => (
                                    <div
                                      key={subIndex}
                                      className="d-flex align-items-center subPermissionContainer ps-3 pt-1"
                                    >
                                      <Input
                                        type="checkbox"
                                        checked={
                                          values?.userPermissions?.[
                                            permission
                                          ]?.[subPermission] || false
                                        }
                                        onChange={() =>
                                          toggleSubPermission(
                                            permission,
                                            subPermission,
                                            values,
                                            setFieldValue
                                          )
                                        }
                                        className="secondary-black m-0"
                                        style={{
                                          borderColor: "#525252",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      <span className="ps-2 text-capitalize  ff-sora">
                                        {subPermission}
                                      </span>
                                    </div>
                                  )
                                )}
                              </div>
                            </Col>
                          );
                        }
                      )}
                  </Row>
                  <Row>
                    <Col xs={12}>
                      {/* Submit Button */}
                      <div className="d-flex justify-content-end mt-4">
                        <Button
                          type="submit"
                          className="me-2 rounded-pill"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            isUpdate ? (
                              <span>Updating...</span>
                            ) : (
                              <span>Adding...</span>
                            )
                          ) : isUpdate ? (
                            "Update Staff"
                          ) : (
                            "Add Staff"
                          )}
                        </Button>
                        <Button
                          color="white"
                          className="rounded-pill1"
                          onClick={() => {
                            resetForm();
                            setEquipmentFiles({ files: [] });
                            setImage("");
                            if (isUpdate) {
                              navigate("/list-staff");
                            }
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "60px",
              position: "sticky",
              bottom: "0",
              zIndex: "10",
            }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default AddStaff;
